import { createRouter, createWebHistory } from 'vue-router'
import HomeNew from '../views/HomeNew.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeNew  // 使用新的大气版首页
  },
  {
    path: '/equipment/single-wire',
    name: 'EquipmentSingleWire',
    component: () => import('../views/EquipmentDetail.vue'),
    props: { type: 'single-wire' }
  },
  {
    path: '/equipment/multi-beam',
    name: 'EquipmentMultiBeam',
    component: () => import('../views/EquipmentDetail.vue'),
    props: { type: 'multi-beam' }
  },
  {
    path: '/equipment/titanium',
    name: 'EquipmentTitanium',
    component: () => import('../views/EquipmentDetail.vue'),
    props: { type: 'titanium' }
  },
  {
    path: '/services/lattice',
    name: 'ServicesLattice',
    component: () => import('../views/ServiceDetail.vue'),
    props: { type: 'lattice' }
  },
  {
    path: '/services/concrete',
    name: 'ServicesConcrete',
    component: () => import('../views/ServiceDetail.vue'),
    props: { type: 'concrete' }
  },
  {
    path: '/services/titanium-alloy',
    name: 'ServicesTitaniumAlloy',
    component: () => import('../views/ServiceDetail.vue'),
    props: { type: 'titanium-alloy' }
  },
  {
    path: '/solutions/ship',
    name: 'SolutionsShip',
    component: () => import('../views/SolutionDetail.vue'),
    props: { type: 'ship' }
  },
  {
    path: '/solutions/platform',
    name: 'SolutionsPlatform',
    component: () => import('../views/SolutionDetail.vue'),
    props: { type: 'platform' }
  },
  {
    path: '/solutions/deep-sea',
    name: 'SolutionsDeepSea',
    component: () => import('../views/SolutionDetail.vue'),
    props: { type: 'deep-sea' }
  },
  {
    path: '/equipment',
    redirect: '/equipment/single-wire'
  },
  {
    path: '/services',
    redirect: '/services/lattice'
  },
  {
    path: '/solutions',
    redirect: '/solutions/ship'
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue')
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('../views/NewsDetail.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
